/* OneTimeRenderer.js */

"use strict";
const DateTimePickerPopup = require("../../common_components/date_time_picker_popup/DateTimePickerPopupComponent");
const BaseScheduleRenderer = require("../../base/BaseScheduleRenderer");
const RendererUtils = require("../../base/RendererUtils");

class OneTimeRenderer extends BaseScheduleRenderer {
    constructor(model) {
        super(model);
    }
    render(formContainerElem) {
        if (this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._onDateTimePickerComp = new DateTimePickerPopup(this._model, "on");
                this._parts = RendererUtils.groupGridRowElements(
                    formContainerElem,
                    "on",
                    "On",
                    this._onDateTimePickerComp
                );
                return this._onDateTimePickerComp.renderer.render();
            })
            .then(() => {
                this._setTheme(this._model.theme);
                this._registerListeners();
                this.setRendered(true);
            });
    }
    getParts() {
        return this._parts;
    }
    shutdown() {
        if (!this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._unregisterListeners();
                return Promise.all([super.shutdown(), this._onDateTimePickerComp.shutdown()]);
            })
            .then(() => {
                this._parts = undefined;
                this._onDateTimePickerComp = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }
    _setControlValuesFromModel() {}
}
module.exports = OneTimeRenderer;
